import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { Locale } from '@services/workout.service.ts';

interface TranslationStatusProps {
  availableTranslations: { [key in Locale]?: boolean };
}

const locales: Locale[] = ['uk', 'en', 'ru', 'cs', 'es', 'pl', 'be'];

const flagEmojis: Record<Locale, string> = {
  uk: '🇺🇦',
  en: '🇬🇧',
  ru: '🇷🇺',
  cs: '🇨🇿',
  es: '🇪🇸',
  pl: '🇵🇱',
  be: '🇧🇾',
};

export const TranslationStatus: React.FC<TranslationStatusProps> = ({ availableTranslations }) => {
  if (!availableTranslations) {
    return null;
  }

  const allTranslationsAvailable = locales.every(lang => availableTranslations[lang]);

  if (allTranslationsAvailable) {
    return (
      <Tooltip title="Всі переклади доступні">
        <LanguageIcon color="success" sx={{ fontSize: '1.5rem' }} />
      </Tooltip>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
      {locales.map((lang) => {
        const isAvailable = availableTranslations[lang];
        return (
          <Tooltip key={lang} title={isAvailable ? `Переклад є (${lang})` : `Переклад відсутній (${lang})`}>
            <Typography
              component="span"
              sx={{
                fontSize: '1.2rem',
                opacity: isAvailable ? 1 : 0.2,
                filter: isAvailable ? 'none' : 'grayscale(100%)',
                cursor: 'help',
                transition: 'opacity 0.2s',
                '&:hover': {
                  opacity: 1,
                  filter: 'none'
                }
              }}
            >
              {flagEmojis[lang]}
            </Typography>
          </Tooltip>
        );
      })}
    </Box>
  );
};
